import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    width: '100%',
    minHeight: '100vh',

    '*:hover::-webkit-scrollbar': {
      width: '0.6em',
    },
  },

  mainWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100vh',
    overflowY: 'auto',
  },

  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    heigth: '100%',
    maxWidth: contentMaxWidth,
    padding: '0 1.25rem 1.25rem 1.25rem',
    marginTop: '1rem',
  },
}))

export { useStyles }
